import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { fadeInUp } from "../../lib/brand";

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <p
    className={`uppercase tracking-[0.22em] text-xs md:text-sm font-semibold font-body ${
      light ? "text-summit-gold-light" : "text-summit-gold-dark"
    } ${className}`}
  >
    {children}
  </p>
);

export const GoldRule = ({ className = "" }) => <div className={`gold-rule ${className}`} />;

export const SectionHeading = ({ eyebrow, title, copy, light = false, align = "left", className = "" }) => (
  <motion.div
    {...fadeInUp}
    className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl ${className}`}
  >
    {eyebrow && <Eyebrow light={light} className="mb-5">{eyebrow}</Eyebrow>}
    <h2
      className={`font-heading text-4xl md:text-5xl font-light leading-[1.1] tracking-tight ${
        light ? "text-white" : "text-summit-charcoal"
      }`}
    >
      {title}
    </h2>
    {copy && (
      <p
        className={`mt-6 font-body text-base md:text-lg leading-relaxed ${
          light ? "text-white/75" : "text-summit-text-muted"
        }`}
      >
        {copy}
      </p>
    )}
  </motion.div>
);

export const PrimaryLink = ({ to, children, testId, className = "" }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`group inline-flex items-center gap-3 bg-summit-forest hover:bg-summit-forest-dark text-white font-body text-sm font-medium tracking-wide px-7 h-13 py-4 transition-colors ${className}`}
  >
    {children}
    <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
  </Link>
);

export const SecondaryLink = ({ to, children, testId, light = false, className = "" }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`group inline-flex items-center gap-3 font-body text-sm font-medium tracking-wide px-7 py-4 border transition-colors ${
      light
        ? "border-white/40 text-white hover:bg-white hover:text-summit-forest"
        : "border-summit-charcoal/25 text-summit-charcoal hover:border-summit-gold hover:text-summit-gold-dark"
    } ${className}`}
  >
    {children}
    <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
  </Link>
);

export const TextLink = ({ to, children, testId, className = "" }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`group inline-flex items-center gap-2 font-body text-sm font-semibold text-summit-forest hover:text-summit-gold-dark transition-colors ${className}`}
  >
    <span className="link-underline">{children}</span>
    <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
  </Link>
);
